import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { backendURL } from '../../App';
import { clearPendingVerify } from '../../helpers/pendingVerify';
import axios from 'axios';
import consoleLog from '../../helpers/consoleLog';
import { homeForUser, userTypeOf } from '../../helpers/userRouting';

export const VerifyEmailFromKey: React.FC<{}> = () => {
  const { key } = useParams<{ key: string }>();

  useEffect(() => {
    axios
      .post(`${backendURL}auth/email-verification/`, { key })
      .then(r => {
        localStorage.setItem('skillsSurveyUserToken', r.data.token);
        localStorage.setItem('skillsSurveyUserID', r.data.user.id);
        localStorage.setItem('skillsSurveyUserType', userTypeOf(r.data.user));
        clearPendingVerify();
        // Hard redirect: компонент без motion.div не даёт AnimatePresence
        // завершить exit-анимацию — старый <main> зависает поверх нового pages.
        window.location.href = homeForUser(r.data.user);
      })
      .catch(err => {
        consoleLog('error', 'email-verification', err);
        window.location.href = '/verify-email';
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <main className='verifyEmail'>Подтверждаем email...</main>;
};
